class SpeedSocietyOffer extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }
  
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    
    // Wait for DOM to fully load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }
  
  init() {
    // Get section ID
    this.sectionId = this.getAttribute('section-id');
    
    if (!this.sectionId) {
      console.error('SpeedSocietyOffer: No section-id attribute provided');
      return;
    }
    
    // Initialize functionality
    this.setupTabButtons();
    this.setupBuyNowButtons();
  }
  
  setupTabButtons() {
    const tabButtons = document.querySelectorAll(`.tab-button-item-${this.sectionId}`);
    const subscriptionItems = document.getElementById('subscription-items');
    const onetimeItems = document.getElementById('onetime-items');
    
    if (!subscriptionItems || !onetimeItems || tabButtons.length === 0) {
      console.error('SpeedSocietyOffer: Required elements not found');
      return;
    }
    
    // Add click event listeners to tab buttons
    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        // Remove active class from all buttons
        tabButtons.forEach(btn => {
          btn.classList.remove(`tab-button-item-active`);
          btn.classList.remove(`tab-button-item-active-${this.sectionId}`);
        });
        
        // Add active class to clicked button
        button.classList.add(`tab-button-item-active`);
        button.classList.add(`tab-button-item-active-${this.sectionId}`);
        
        // Show corresponding content
        const type = button.getAttribute('data-type');
        if (type === `subscription-${this.sectionId}`) {
          subscriptionItems.classList.add('item-list-active');
          onetimeItems.classList.remove('item-list-active');
        } else {
          subscriptionItems.classList.remove('item-list-active');
          onetimeItems.classList.add('item-list-active');
        }
      });
    });
  }
  
  setupBuyNowButtons() {
    const itemImages = document.querySelectorAll('.item-parent');
    
    itemImages.forEach(image => {
      image.addEventListener('click', (event) => {
        // Prevent default image action
        event.preventDefault();
        
        // Add loading state to the image
        image.classList.add('is-loading');
        
        // Get product data from image attributes
        const variantId = image.getAttribute('data-variant-id');
        const sellingPlanId = image.getAttribute('data-selling-plan');
        const entries = image.getAttribute('data-entry');
        const giveaway = image.getAttribute('data-giveaway');
        
        if (!variantId) {
          console.error('SpeedSocietyOffer: No variant ID found');
          image.classList.remove('is-loading');
          return;
        }
        
        // Create cart data object
        let formData = {
          'items': [{
            'id': variantId,
            'quantity': 1,
            'properties': {}
          }]
        };
        
        // Add properties if they exist
        if (entries && entries !== 'null' && entries !== 'undefined') {
          formData.items[0].properties['Entries'] = entries;
        }
        
        // Add giveaway property if it exists
        if (giveaway && giveaway !== 'null' && giveaway !== 'undefined') {
          formData.items[0].properties['Giveaway'] = giveaway;
        }
        
        // Add selling plan if it exists (for subscription products)
        if (sellingPlanId && sellingPlanId !== 'null' && sellingPlanId !== 'undefined') {
          formData.items[0].selling_plan = sellingPlanId;
        }
        
        // Add to cart and redirect to cart page
        this.addToCart(formData, image);
      });
    });
  }
  
  addToCart(formData, element) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(async response => {
      if (response.ok) {
        // Sync the cart-level total entries attribute before leaving the page.
        try {
          const cart = await fetch('/cart.js').then((r) => r.json());
          await updateCartEntriesAttribute(cart);
        } catch (e) {
          console.error('SpeedSocietyOffer: could not update entries attribute', e);
        }

        // Dispatch an event for successful cart addition
        const event = new CustomEvent('speed-society:product-added', {
          bubbles: true,
          detail: { formData }
        });
        this.dispatchEvent(event);

        // Redirect to cart page
        window.location.href = '/cart';
      } else {
        // Handle error response
        return response.json().then(data => {
          throw new Error(data.description || 'Could not add product to cart');
        });
      }
    })
    .catch(error => {
      console.error('Error adding product to cart:', error);
      element.classList.remove('is-loading');
      alert(error.message || 'Could not add product to cart. Please try again.');
    });
  }
  
  disconnectedCallback() {
    // Clean up if needed when component is removed
  }
}

// Register the custom element
customElements.define('speed-society-offer', SpeedSocietyOffer);